import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { onFetchBlogs } from './action';

export default function Index() {
  const dispatch = useDispatch();
  const products = useSelector((state) => state.BestSeller.allData)

  useEffect(() => {
    if (!products.length > 0) {
      dispatch(onFetchBlogs());
    }
  }, [dispatch, products.length]);
}